import { render, staticRenderFns } from "./team-calendar.vue?vue&type=template&id=6fd543a0&"
import script from "./team-calendar.vue?vue&type=script&lang=ts&"
export * from "./team-calendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports